import bridge from '@vkontakte/vk-bridge';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { AppConfig } from './app/AppConfig';
import './i18n';

/**
 * VKWebAppInit отправляем самой первой строкой, до отрисовки и до загрузки
 * основных ресурсов: по документации ВК на это есть 30 секунд с момента
 * запуска, иначе клиент считает, что приложение не поднялось, и показывает
 * пользователю ошибку. Ответ нам не нужен — важен сам факт отправки.
 */
void bridge.send('VKWebAppInit').catch(() => {
  // Открыли вне ВК (локальная разработка) — моста нет, и это нормально.
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('В index.html нет элемента #root — монтировать приложение некуда');
}

createRoot(container).render(
  <StrictMode>
    <AppConfig>
      <App />
    </AppConfig>
  </StrictMode>,
);
